<template>
	<div class="h100p pos-relative home">

    <div class="home-slide">
      <div class="text-center">
        <img class="block w100p" :src="'/static/images/home/banner_01.jpg'" alt="">
      </div>
    </div>

    <div class="section">
      
      <div class="clear intro-list intro-list-1" style="margin: 0 auto; max-width: 2000px">
        <div class="clear" v-for="(item, index) in intro.list1">
          <div class="clear pos-relative intro-list-item"
               v-if="index%2 !== 0">
            <div class="fl w50p intro-list-img left">
              <img class="w100p" :src="item.img" alt="">
            </div>
            <div class="fr w50p pd-l20 intro-list-text right">
              <div class="intro-list-title">
                {{ item.title }}
              </div>
              <div class="intro-list-description">
                {{ item.description }}
              </div>
            </div>
          </div>
    
          <div class="clear pos-relative intro-list-item"
               v-if="index%2 === 0">
            <div class="fl w50p pd-l100 pd-r100 intro-list-text display-table left">
              
              <div class="display-table-cell v-m">
                <div class="intro-list-title">
                  {{ item.title }}
                </div>
                <div class="intro-list-description">
                  {{ item.description }}
                </div>
              </div>
              
            </div>
            <div class="fr w50p intro-list-img right">
              <img class="w100p" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      
      <div class="w1200 block-center intro-list intro-list-2">
        
        
        <div class="clear" v-for="(item, index) in intro.list2">
          <div class="clear pos-relative intro-list-item"
               :class="'intro-list-item-' + index"
               v-if="index%2 === 0">
            <div class="fl w50p intro-list-img">
              <img class="w100p" :src="item.img" alt="">
            </div>
            <div class="fr w50p h100p pd-l20 display-table pos-abs t0 r0 intro-list-text">
              
              <div class="display-table-cell v-m">
                <div class="intro-list-title">
                  {{ item.title }}
                </div>
                <div class="intro-list-description">
                  {{ item.description }}
                </div>
              </div>
              
            </div>
          </div>
          
          <div class="clear pos-relative intro-list-item"
               :class="'intro-list-item-' + index"
               v-if="index%2 !== 0">
            <div class="fl w50p h100p pd-r20 display-table pos-abs t0 l0 intro-list-text">
  
              <div class="display-table-cell v-m">
              
                <div class="intro-list-title">
                  {{ item.title }}
                </div>
                
                <div class="intro-list-description">
                  {{ item.description }}
                </div>
              </div>
            </div>
            <div class="fr w50p intro-list-img">
              <img class="w100p" :src="item.img" alt="">
            </div>
          </div>
        </div>
        
      </div>
    </div>


    <div class="mg-b50 section">

      <div class="w1200 block-center h50 pos-relative z2">
        <img class="icon-section direction-icon-flag" :src="'/static/images/home/icon_flag.png'" alt="">
      </div>
      <div class="pos-relative direction">
        <div class="bg-img text-center direction-bg-img">
          <img class="block-center" :src="'/static/images/home/bg_banner_01.jpg'" alt="">
        </div>

        <div class="color-white f0 pd-l60 pos-abs t80 r50p z2 section-text-box">
          <img class="pos-abs pos-c-l" :src="'/static/images/home/icon_triangle.png'" alt="">
          <span class="f20 mg-r40">重点方向</span>
          <span class="f20">DIRECTION</span>
          <span class="h-line"></span>
        </div>
      </div>

    </div>

    <div class="mg-b50 section">
      <div class="text-center section-cat-title">
        <div class="h-line">
          <div class="icon-diamond icon-diamond-left"></div>
          <div class="icon-diamond icon-diamond-right"></div>
        </div>

        <div class="f22 inline-block section-cat-title-text">
          {{ business.title }}
        </div>
      </div>

      <div class="mg-b30 cat-description">
        <div class="cat-description-text-box">
          {{ business.description }}
        </div>
      </div>
      
      <div class="pd-l60 pd-r60 cat-content">
        
        
        <div class="clear business">
          <div class="fl business-list-item" v-for="(item, index) in business.list">
            <div class="mg-b20 pos-relative business-list-item-box">
              <div class="w100p pos-abs t0 l0 business-list-item-img">
                <img class="w100p h100p" :src="item.img" alt="">
              </div>
              
              <div class="business-list-item-cat-title">
                {{ item.catTitle }}
                <img class="icon-business-list-item" :src="'/static/images/home/icon_business_list_item.jpg'" alt="">
              </div>
            </div>
            
            <div class="pos-relative excerpt">
              <div class="lh36 max-h110 overflow-hidden excerpt-content">
                {{ item.excerpt }}
              </div>
  
              <div class="pos-abs r0 b20 excerpt-content-view-more">
                <img class="mouse-pointer max-h100p v-m" :src="'/static/images/home/icon_business_view_more.png'" alt="">
              </div>
            </div>
          </div>
        </div>
        
        <!--<div class="pd-tb20 block-center">
          <div class="d-flex justify-content-space-between business-list">
            <div class="w33p pos-relative business-list-item" v-for="(item, index) in business.list">
              <div class="w100p text-center business-list-item-img">
                <img class="w100p" :src="item.img" alt="">
              </div>
              <div class="business-list-item-cat-title">
                {{ item.catTitle }}
                <img class="icon-business-list-item" :src="'/static/images/home/icon_business_list_item.jpg'" alt="">
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>

    <div class="mg-b50 section">

      <div class="w1200 block-center h50 pos-relative z2">
        <img class="icon-section direction-icon-flag" :src="'/static/images/home/icon_scenery.png'" alt="">
      </div>
      <div class="pos-relative direction">
        <div class="bg-img text-center direction-bg-img">
          <img class="block block-center" :src="'/static/images/home/bg_banner_02.jpg'" alt="">
        </div>

        <div class="color-white f0 pd-l60 pos-abs t80 r50p z2 section-text-box">
          <img class="pos-abs pos-c-l" :src="'/static/images/home/icon_triangle.png'" alt="">
          <span class="f20 mg-r40">公司新闻</span>
          <span class="f20">NEWS</span>
          <span class="h-line"></span>
        </div>
      </div>

    </div>

    <div class="section">

      <div class="block-center w1200">

        <div class="news-list">
          <div class="clear mg-b100 news-list-item" v-for="(item, index) in news.list">
            <div class="fl w340 h230">
              <img :src="item.img" :alt="item.title">
            </div>

            <div class="mg-l400">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="excerpt">
                {{ item.excerpt }}
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <!--<div class="section friendly-links">

      <div class="text-center section-cat-title">
        <div class="h-line">
          <div class="icon-diamond icon-diamond-left"></div>
          <div class="icon-diamond icon-diamond-right"></div>
        </div>

        <div class="f22 inline-block section-cat-title-text">
          {{ friendlyLinks.title }}
        </div>
      </div>

      <div class="clear w1200 block-center friendly-links-list">
        <div class="friendly-links-item-wrap" v-for="(item, index) in friendlyLinks.list">
          <a class="block h70 pos-relative friendly-links-item" :href="item.href">
            <img class="pos-abs pos-c" :src="item.img" alt="">
          </a>
        </div>
      </div>
    </div>-->

	</div>
</template>

<script>

	export default {
		name: "home",

		data() {
			return {
        intro: {
          
          list1: [
            {
              img: '/static/images/home/intro_list_item_img_01.jpg',
              title: '量身定做科学、合理的保险方案 ►►► 保险设计师',
              description: '通过风险调研和风险识别，组织行业专家协助客户鉴别和衡量运营中存在的各种风险。遵循成本效益原则，为客户制定科学、合理、创新的保险方案，充分发挥保险的风险转嫁功能，切实转嫁客户潜在的经营风险。'
            },
            
          ],
          
          list2: [
            {
              img: '/static/images/home/intro_list_item_img_02.jpg',
              title: '合理、有效控制保险采购成本 ►►► 保险采购专家',
              description: '通过对保险采购方式的比较分析，结合客户内部管理采购要求，运用公司强大的议价能力和资源整合能力，为客户选择适合的保险公司，合理、有效地控制保险采购成本。'
            },
            {
              img: '/static/images/home/intro_list_item_img_03.jpg',
              title: '完善保险管理体系 ►►► 保险管理顾问',
              description: '结合客户实际经营管理情况，协助客户建立规范的保险管理体系，实现保险规范管理。'
            },
            {
              img: '/static/images/home/intro_list_item_img_04.jpg',
              title: '设立索赔控制机制 ►►► 保险索赔能手',
              description: '为了保证索赔的顺利进行，我们采用理赔制度保障机制，明确索赔处理规则，通过事先制定标准的赔案处理流程、疏通索赔渠道、赔案数据分析报告制度等手段，提高案件的成功获赔比例，实现保险索赔的科学化、制度化管理。'
            },
            {
              img: '/static/images/home/intro_list_item_img_05.jpg',
              title: '建立风险管理体系 ►►► 风险管理专家',
              description: '采用保险与其他风险管理手段互动结合的方式进行全面的风险管理，包括风险管理体系的建立，现场查勘的落实，风险评估的标准化，安全检查的日常化等一系列风险举措，协助客户加强风险管控力度，提升风险防范水平，丰富对可控风险的管理和对不可控风险转嫁的方法，力求降低自然灾害、意外事故等风险对客户运营的不利影响，完善风险管理体系。'
            }
          ]
        },

        business: {
          title: '业务领域',
          description: '专业引领、深耕细作。和德经纪在现有市场环境中寻求适合自身的独特发展方向，选择某一细分领域，通过持续的经验积累和精耕细作，不断完善在该领域的经营模式，以期形成难以复制的独特商业模式和可持续的市场竞争力，为客户提供优质的服务方案。',
          list: [
            {
              img: '/static/images/home/business_item_img_01.jpg',
              catTitle: '交通运输',
              catContent: '公交、地铁、出租车、私家车、货车等各种交通方式是我国居民日常出行、生产经营的重要支持，和德经纪有着优秀的专业服务团队...',
              excerpt: '公交、地铁、出租车、私家车、货车等各种交通方式是我国居民日常出行、生产经营的重要支持，和德经纪有着优秀的专业服务团队...'
            },

            {
              img: '/static/images/home/business_item_img_02.jpg',
              catTitle: '教育安全',
              catContent: '加强学校安全工作是全面贯彻党的教育方针，保障学生健康成长、全面发展的前提和基础，关系广大师生的人身安全，事关亿万家庭...',
              excerpt: '加强学校安全工作是全面贯彻党的教育方针，保障学生健康成长、全面发展的前提和基础，关系广大师生的人身安全，事关亿万家庭...'
            },

            {
              img: '/static/images/home/business_item_img_03.jpg',
              catTitle: '互联网保险',
              catContent: '和德经纪运用互联网、大数据、人工智能与区块链等新技术，探索互联网保险经纪业务创新、服务创新，提高保险经营效率，改善...',
              excerpt: '和德经纪运用互联网、大数据、人工智能与区块链等新技术，探索互联网保险经纪业务创新、服务创新，提高保险经营效率，改善...'
            },
          ]
        },

        news: {
          list: [
            // {
            //   img: '/static/images/home/news_list_item_img_01.jpg',
            //   title: '和德经纪进军航天保险市场',
            //   excerpt: '2021年10月14日18时51分，长征二号丁运载火箭在太原卫星发射中心点火升空，成功将多颗卫星送入预定轨道，发射任务取得圆满成功。本次成功发射的“轨道大气密度探测卫星”是和德保险经纪有限公司作为保险经纪人服务的第一个航天保险项目，标志着和德经纪正式进军航天保险市场。'
            // },

            {
              img: '/static/images/home/news_list_item_img_01.jpg',
              title: '和德经纪进军航天保险市场',
              excerpt: '2021年10月14日18时51分，长征二号丁运载火箭在太原卫星发射中心点火升空，成功将多颗卫星送入预定轨道，发射任务取得圆满成功。本次成功发射的“轨道大气密度探测卫星”是和德保险经纪有限公司作为保险经纪人服务的第一个航天保险项目，标志着和德经纪正式进军航天保险市场。'
            }
          ]
        },

        friendlyLinks: {
          title: '合作伙伴',
          list: [
            // {
            //   img: '/static/images/home/friendly_link_img_01.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_02.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_03.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_04.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_05.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_06.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_07.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_08.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_09.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_10.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_11.png',
            //   href: ''
            // },
            // {
            //   img: '/static/images/home/friendly_link_img_12.png',
            //   href: ''
            // }
          ]
        }
      }
		},

		methods: {

		},

		mounted() {

		}
	}
</script>
